export default "__VITE_PUBLIC_ASSET__97c3bea3__"